import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { requireAdmin } from '@/lib/auth-guards'
import { Payments } from '@/features/payments'

const paymentsSearchSchema = z.object({
  userId: z.string().optional().catch(''),
  membershipId: z.string().optional().catch(''),
  date: z.string().optional().catch(''),
  startDate: z.string().optional().catch(''),
  endDate: z.string().optional().catch(''),
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  tab: z.enum(['payments', 'refunds']).optional().catch('payments'),
})

export const Route = createFileRoute('/_authenticated/payments/')({
  beforeLoad: requireAdmin,
  component: Payments,
  validateSearch: paymentsSearchSchema,
})
